/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import {
    Polymer,
    html
} from '@polymer/polymer/polymer-legacy.js';

const template = html `
        <style include="app-styles mdl-grid-css">
            oe-info {
                font-size: inherit;
                --oe-info-value: {
                    font-size: var(--a-font-size-s);
                    color: var(--secondary-dark-color);
                    padding: 0px;
                }
                ;
                --oe-info-label: {
                    padding: 0px;
                }
                ;
            }
        </style>
        <!-- AJAX calls to fetch bill-presentment for the previous bills paid that was due to the user-->
        <oe-ajax id="ajaxBillerRecentTransaction" method="get" handle-as="json" content-type="application/json" on-response="recentTransactionRequest"
            on-error="showError"></oe-ajax>

        <!-- Total expenditure -->
        <template is="dom-if" if="{{transactDetails.length}}">
            <!-- <paper-card class='list-card-primary' elevation='0'> -->
            <oe-hbox id='total-expenditure-container' class="mdl-grid padding-b-zero">
            <div aria-labelledby="transactionHistory"></div>
            <span id="transactionHistory" class="display-none" aria-hidden="true"><oe-i18n-msg msgid="transactions history section"></oe-i18n-msg></span>
                <oe-vbox  class="mdl-cell mdl-cell--2-col-phone mdl-cell--4-col-tablet mdl-cell--6-col-desktop">
                    <oe-i18n-msg aria-hidden="true" class="title-dark primary-dark-text-m" msgid="h_TotalSpent"></oe-i18n-msg>
                  <div id="NumberOfTransBills" class="secondary-dark-text-s">
                    <span aria-labelledby="totalSpent">
                      <div id="totalSpent" class="display-none">
                      <oe-i18n-msg msgid="h_TotalSpent"></oe-i18n-msg></div>   
                    </span>
                        {{transactDetails.length}}
                        <oe-i18n-msg msgid="l_Transactions"></oe-i18n-msg>
                    </div>
                </oe-vbox>
                <oe-vbox class="mdl-cell mdl-cell--2-col-phone mdl-cell--4-col-tablet mdl-cell--6-col-desktop text-align-right">
                    <div id="TotalSpentBillPayment" class="primary-dark-text-l font-weight-bold">
                    <span aria-labelledby="lastOneYear">
                      <div id="lastOneYear" class="display-none">
                      <oe-i18n-msg msgid="l_LastOneYear"></oe-i18n-msg></div>   
                    </span>
                    {{symbolizeCurrency(transactDetails,total)}}</div>
                    
                    <oe-i18n-msg aria-hidden="true" class="secondary-dark-text-s" msgid="l_LastOneYear"></oe-i18n-msg>
                </oe-vbox>
            </oe-hbox>
            <!-- </paper-card> -->
            <div class="mdl-grid padding-b-zero padding-t-zero">
                <div class="border-b-1px mdl-cell full-width padding-t-zero"></div>
            </div>
        </template>

        <!-- Total expenditure -->
        <template is="dom-if" if="{{!transactDetails.length}}">
            <!-- <paper-card class='list-card-primary' elevation='0'> -->
            <div id='total-expenditure-container'>
               <supporting-msg  description="m_noTransactionsBillsDesc" icon-name="no_txn" background="light-background" title-msg="m_noTransactions"></supporting-msg>
            </div>
            <!-- </paper- card> -->
        </template>
       
        <!-- List of previous transactions -->

        <div id='previous-trans-container'>
            <template is="dom-if" if="{{transactDetails.length}}">
                <biller-previous-transactions transact-details="{{lastTransact}}"></biller-previous-transactions>
            </template>
        </div>`;


Polymer({
    is: "bill-transaction-history",
    _template: template,
    properties: {
        billerDetails: {
            type: Object,
            notify: true,
            observer: '_fireBillPresentment'
        },
        total: {
            type: Number,
            notify: true
        },
        transactDetails: {
            type: Array,
            notify: true,
            observer: '_setLastTrans'
        },
        lastTransact: {
            type: Array,
            notify: true
        }
    },
    ready: function () {
        this.dateFormat = clientStorage.get(storageType.session, 'dateFormat');

    },
    //Parse standard Date format to accepted date format
    dateParse: function (d) {
        return d.toISOString().slice(0, 19);
    },
    //Observer for billerDetails
    _fireBillPresentment: function () {
        var date = getNewDate();
        this.userId = clientStorage.get(storageType.session, 'userId');
        var billerType;
        if (this.billerDetails.billerType && this.billerDetails.billerType.cmCode == 'SP')
            billerType = "B";
        else
            billerType = "S";

        this.$.ajaxBillerRecentTransaction.url = '/api/CBUsers/' + this.userId + '/transactionsrequests'
        this.$.ajaxBillerRecentTransaction.url += "?filter[where][transactionDate][between][0]=" +
            this.dateParse(getNewDate(date.setFullYear(date.getFullYear() - 1))) +
            "&filter[where][transactionDate][between][1]=" + this.dateParse(getNewDate()) +
            "&filter[where][counterpartyAccount]=" + this.registrationId + "&filter[where][counterpartyType]=" + billerType + "&filter[order]=transactionDate DESC";

        this.$.ajaxBillerRecentTransaction.generateRequest();
    },
    _setLastTrans: function () {
        this.gotTransactions();
        if (!this.lastTransact) {
            this.lastTransact = this.transactDetails;
        }
    },
    // filter and get the entry till first instance of "|"
    // filter and get the entry till first instance of "|"
    filterSubscription: function (input) {
        if (typeof input == 'undefined')
            return;
        if (input.indexOf("|") == '-1')
            return input;
        return input.substr(0, input.indexOf("|"));
    },
    //Format currency for total, average and item balance
    symbolizeCurrency: function (curr, amount) {

        if (typeof curr === 'object' && curr.length == 0)
            return "no transactions yet";
        if (typeof curr === 'object')
            curr = curr[0].transactionCurrency.cmCode;
        return currency.symbolize(curr + " " + amount);
    },
    //Response of bill-presentment API
    recentTransactionRequest: function (event) {
        // var temp = [];
        // for (var i = 0; i < event.detail.response.length; i++) {
        //     if (event.detail.response[i].toAccountNickname == this.billerDetails.billerNickname) {
        //         temp.push(event.detail.response[i]);
        //     }
        // }
        this.transactDetails = event.detail.response;
        var numberOfTransactions = this.transactDetails.length;
        if (numberOfTransactions > 3) {
            this.lastTransact = this.transactDetails;
            this.lastTransact = this.lastTransact.sort((a, b) => parseInt(a.requestReferenceId) < parseInt(b.requestReferenceId) && 1 || -1).slice(0, 3);
        }
        else this.lastTransact = this.transactDetails;

    },
    //Total and average calculation
    gotTransactions: function () {
        var length = this.transactDetails.length;
        var avg = 0;
        for (var i = 0; i < length; i++) {
            avg += parseInt(this.transactDetails[i].totalTransactionAmount);
        }
        this.total = avg;
        avg = avg / length;
        this.avg = avg;
    },
    //Extract Hours as per UX
    extractHour: function (datetime) {
        var d = getNewDate(datetime);
        return d.getHours() + ":" + d.getMinutes();
    },
    showError: function () {
        this.set('transactDetails', []);
    }
});
